// Loading.js
import React from 'react';
import PropTypes from 'prop-types';
import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * Zentrierter Lade‑Spinner.
 *
 * @param {Object}   props
 * @param {string}   [props.text]   Optionaler Hinweis‑Text unter dem Spinner.
 * @param {number}   [props.size]   Größe des CircularProgress (Standard: 40).
 * @param {string}   [props.color]  Farbe des Spinners (Standard: "primary").
 */
const Loading = ({ text, size = 40, color = 'primary' }) => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',          // vertikale Zentrierung über die gesamte Viewport‑Höhe
        }}
    >
        <CircularProgress size={size} color={color} />
        {text && (
            <Typography variant="body1" sx={{ mt: 2 }}>
                {text}
            </Typography>
        )}
    </Box>
);

Loading.propTypes = {
    text: PropTypes.string,
    size: PropTypes.number,
    color: PropTypes.oneOf(['inherit', 'primary', 'secondary', 'error', 'info', 'success', 'warning']),
};

Loading.defaultProps = {
    text: '',
    size: 40,
    color: 'primary',
};

export default Loading;
